import { gql } from "@apollo/client";

/**
 * One turn of the support conversation. The whole conversation is resent each
 * turn — the client holds it, because a conversation nobody files is not worth a
 * table, and one that is filed is copied onto the row entire.
 *
 * `filed` and `request` are what the panel renders as „Užregistravau #REF". That
 * card is not decoration: the model decides whether to file, and a decision the
 * person cannot see is the one failure mode of letting it decide.
 */
export const SEND_SUPPORT_MESSAGE = gql`
  mutation SendSupportMessage($messages: [SupportMessageInput!]!, $path: String, $learnerId: ID) {
    sendSupportMessage(messages: $messages, path: $path, learnerId: $learnerId) {
      reply
      options
      filed
      degraded
      errors
      request {
        id
        category
        categoryLabel
        summary
      }
    }
  }
`;

/**
 * „Vis tiek registruoti" — the person overruling the model, and the whole route
 * when there is no provider at all.
 */
export const FILE_SUPPORT_REQUEST = gql`
  mutation FileSupportRequest(
    $category: String!
    $messages: [SupportMessageInput!]!
    $path: String
    $learnerId: ID
  ) {
    fileSupportRequest(
      category: $category
      messages: $messages
      path: $path
      learnerId: $learnerId
    ) {
      request {
        id
        category
        categoryLabel
        summary
      }
      errors
    }
  }
`;

/** Admin: mark one dealt with, or reopen it. The row is kept either way. */
export const RESOLVE_SUPPORT_REQUEST = gql`
  mutation ResolveSupportRequest($id: ID!, $resolved: Boolean) {
    resolveSupportRequest(id: $id, resolved: $resolved) {
      request {
        id
        status
        resolved
        resolvedAt
      }
      errors
    }
  }
`;
